const Endpoints = {
  business: process.env.REACT_APP_API,
};
export default Endpoints;
